var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2609659"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3025_15174)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10,
    rx: 2,
    fill: "#E3E4E9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 60",
    cx: 1,
    cy: 1,
    r: 2,
    fill: "#202E5F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 62",
    cx: 1,
    cy: 9,
    r: 2,
    fill: "#202E5F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 64",
    opacity: 0.3,
    cx: 8,
    cy: 5,
    r: 3,
    fill: "#202E5F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 61",
    cx: 15,
    cy: 1,
    r: 2,
    fill: "#202E5F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 63",
    cx: 15,
    cy: 9,
    r: 2,
    fill: "#202E5F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3025_15174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.6fcef5401c9819c1484fa038c3138d87.svg";
export { ForwardRef as ReactComponent };